import React from "react";
import { MapPin, Phone, Instagram, Mail, Clock } from "lucide-react";

import { mockData } from "../mock";

const Footer = () => {
  const { phone, instagram, email, links } = mockData.company;

  return (
    <footer className="bg-black border-t border-gray-800 py-16 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Logo and main info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center">
                <MapPin className="w-6 h-6 text-black" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-yellow-400">Eletron</h3>
                <p className="text-gray-400 text-sm">Rastreamento Veicular</p>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              Tecnologia avançada em rastreamento veicular. Segurança, praticidade 
              e tranquilidade para você e sua família.
            </p>
            
            <div className="flex gap-4">
              <a 
                href={links.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-yellow-400 hover:to-orange-500 hover:text-black transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href={`mailto:${email}`}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-yellow-400 hover:to-orange-500 hover:text-black transition-all duration-300"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Serviços</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href="#planos" className="hover:text-yellow-400 transition-colors">Rastreamento Individual</a></li>
              <li><a href="#planos" className="hover:text-yellow-400 transition-colors">Gestão de Frotas</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Relatórios Avançados</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">API de Integração</a></li>
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Suporte</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href={links.whatsapp} className="hover:text-yellow-400 transition-colors">Central de Ajuda</a></li>
              <li><a href={links.demo} className="hover:text-yellow-400 transition-colors">Tutorial do App</a></li>
              <li><a href={links.whatsapp} className="hover:text-yellow-400 transition-colors">Contato Técnico</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Status dos Serviços</a></li>
            </ul>
          </div>
        </div>
        
        {/* Contact info bar */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <a 
                href={`tel:${phone.replace(/\D/g, '')}`} 
                className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span className="font-semibold">{phone}</span>
              </a>
              
              <a 
                href={links.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>{instagram}</span>
              </a>
            </div>
            
            <div className="flex items-center gap-2 text-gray-400">
              <Clock className="w-5 h-5" />
              <span>Atendimento 24h</span>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 Eletron Rastreamento. Todos os direitos reservados.
            </p>
            
            <div className="flex gap-6 text-sm text-gray-500">
              <a href="#" className="hover:text-yellow-400 transition-colors">Termos de Uso</a>
              <a href="#" className="hover:text-yellow-400 transition-colors">Política de Privacidade</a>
              <a href="#" className="hover:text-yellow-400 transition-colors">Cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;